<template>
  <div class="NewList" :class="[language == 'zh' ? 'zhFamily' : 'enfamily']">
    <Banner></Banner>
    <HotNew :activeType="activeType" :dataList="dataList"></HotNew>
    <Search ref="searchVal"></Search>
    <NewsSociety
      :dataList="dataList"
      :moreShowBoolen="moreShowBoolen"
      :videoList="videoList"
      :moreActive="moreActive"
      v-if="activeType == 1"
    ></NewsSociety>

    <NewsTechnology
      :dataList="dataList"
      :moreShowBoolen="moreShowBoolen"
      :videoList="videoList"
      :moreActive="moreActive"
      v-if="activeType == 2"
    ></NewsTechnology>
    <Case
      :dataList="dataList"
      :videoList="videoList"
      :moreShowBoolen="moreShowBoolen"
      :moreActive="moreActive"
      v-if="activeType == 3"
    ></Case>
  </div>
</template>

<script>
import { mapMixin } from "@/util/mixin";
import bus from "@/bus";
import { GetNewsMore } from "@/axios/api.js";
import { searchNews } from "@/axios/news.js";
import { videosList } from "@/axios/video.js";
export default {
  mixins: [mapMixin],
  name: "newslist",
  data() {
    return {
      activeType: 1,
      dataList: [],
      videoList: [],
      pageNum: 1,
      pageSize: 10,
      type: null, //当前新闻类型
      pages: null, //总页面
      moreShowBoolen: false, //更多与无数据
      moreActive: true, //loading显示
      channelName: null,
      mouth: "",
      sdgId: "",
    };
  },

  mounted() {
    this.type = this.$route.query.type;
    this.typeDataList(this.type);
    bus.$on("moreNew", () => {
      this.pageNum++;
      this.moreActive = false;
      setTimeout(() => {
        this.typeDataList(this.type);
      }, 1000);
    });
    bus.$on("searchNewsEmit", (res) => {
      this.dataList = [];
      this.pageNum = 1;

      this.moreShowBoolen = false;
      if (res.mouth) {
        this.mouth = res.mouth;
      } else {
        this.mouth = "";
      }
      if (res.sdgId) {
        this.sdgId = res.sdgId;
      } else {
        this.sdgId = "";
      }
      this.typeDataList(this.type);
    });
  },
  watch: {
    language() {
      this.pageNum = 1;
      this.dataList = [];
      this.videoList = [];
      this.moreShowBoolen = false;
      this.moreActive = true;
      this.type = this.$route.query.type;
      this.mouth = "";
      this.sdgId = "";
      this.typeDataList(this.type);
    },
    $route(to, from) {
      this.pageNum = 1;
      this.dataList = [];
      this.videoList = [];
      this.moreShowBoolen = false;
      this.moreActive = true;
      this.type = to.query.type;
      this.mouth = "";
      this.sdgId = "";
      this.typeDataList(this.type);
    },
  },
  methods: {
    typeDataList(val) {
      if (val == "Technology") {
        this.activeType = 2;
        if (this.language == "zh") {
          this.channelName = "SDGs与科技";
        } else if (this.language == "en") {
          this.channelName = "Science for SDGs";
        } else {
          this.channelName = "ODD et science";
        }
      }
      if (val == "Society") {
        this.activeType = 1;
        if (this.language == "zh") {
          this.channelName = "SDGs与社会";
        } else if (this.language == "en") {
          this.channelName = "SDGs and Society";
        } else {
          this.channelName = "ODD et société";
        }
      }
      if (val == "Case") {
        this.activeType = 3;

        if (this.language == "zh") {
          this.channelName = "实践案例";
        } else if (this.language == "en") {
          this.channelName = "Best Practices";
        } else {
          this.channelName = "Exemples pratiques";
        }
      }
      var param = {
        pageSize: this.pageSize,
        pageNum: this.pageNum,
        channelName: this.channelName,
      };
      if (this.videoList.length == 0) {
        this.GetVideoFun(param);
      }

      if (this.mouth) {
        param.mouth = this.mouth;
      }
      if (this.sdgId) {
        param.sdgId = this.sdgId;
      }
      console.log(param);
      this.moreActive = false;
      this.GetNewsFun(param);
    },
    async GetVideoFun(param) {
      var res = await videosList(param);
      this.videoList = res.data.data.list;
    },
    async GetNewsFun(param) {
      var res = await searchNews(param);
      this.pages = res.data.data.pages;
      console.log(this.pages, this.pageNum);
      if (this.pages == this.pageNum || this.pages == 0) {
        this.moreShowBoolen = true;
      }
      this.dataList = this.dataList.concat(res.data.data.list);
      this.moreActive = true;
      console.log(this.moreActive);
    },
  },

  components: {
    Banner: () => import("../components/NewsList/Banner/Banner.vue"),
    HotNew: () => import("../components/NewsList/HotNew/HotNew.vue"),
    Search: () => import("../components/NewsList/Search/Search.vue"),
    NewsSociety: () => import("../components/NewsList/News/NewsSociety.vue"),
    Case: () => import("../components/NewsList/News/Case.vue"),
    NewsTechnology: () =>
      import("../components/NewsList/News/NewsTechnology.vue"),
    SDG: () => import("../components/NewsList/SDG/SDG.vue"),
  },
};
</script>

<style lang="scss" scoped>
.NewList {
  background: rgba(239, 246, 255, 1);
}
</style>